/**
 * O que fica gravado no navegador sobre a sessão, e só isso.
 */
import { REFRESH_KEY, TOKEN_KEY } from '../api/client';
import { storage } from '../api/storage';
import { contextKey, type AuthTokens, type AvailableContext, type SessionContext, type SessionUser } from './types';

const USER_KEY = 'user';
const CONTEXT_KEY = 'context';
const REMEMBERED_KEY = 'remembered_contexts';
const ISSUED_AT_KEY = 'issued_at';

export const sessionStore = {
  readTokens(): { accessToken: string | null; refreshToken: string | null; issuedAt: number | null } {
    const issued = storage.get(ISSUED_AT_KEY);
    return {
      accessToken: storage.get(TOKEN_KEY),
      refreshToken: storage.get(REFRESH_KEY),
      issuedAt: issued ? Number(issued) : null,
    };
  },
  writeTokens(t: AuthTokens): void {
    storage.set(TOKEN_KEY, t.accessToken);
    storage.set(REFRESH_KEY, t.refreshToken);
    storage.set(ISSUED_AT_KEY, String(Date.now()));
  },
  readUser(): SessionUser | null {
    return storage.getJson<SessionUser>(USER_KEY);
  },
  writeUser(u: SessionUser): void {
    storage.setJson(USER_KEY, u);
  },
  readContext(): SessionContext | null {
    return storage.getJson<SessionContext>(CONTEXT_KEY);
  },
  writeContext(c: SessionContext): void {
    storage.setJson(CONTEXT_KEY, c);
  },
  clear(): void {
    for (const k of [TOKEN_KEY, REFRESH_KEY, USER_KEY, CONTEXT_KEY, ISSUED_AT_KEY]) storage.remove(k);
    // `remembered_contexts` sobrevive ao logout de propósito (A006).
  },

  /** Vínculo lembrado por conta, neste navegador (A006). */
  rememberedFor(userId: string): string | null {
    const mapa = storage.getJson<Record<string, string>>(REMEMBERED_KEY) ?? {};
    return mapa[userId] ?? null;
  },
  remember(userId: string, ctx: AvailableContext | SessionContext): void {
    const mapa = storage.getJson<Record<string, string>>(REMEMBERED_KEY) ?? {};
    mapa[userId] = contextKey({ brandId: ctx.brandId, role: ctx.role, companyId: ctx.companyId ?? null });
    storage.setJson(REMEMBERED_KEY, mapa);
  },
  forget(userId: string): void {
    const mapa = storage.getJson<Record<string, string>>(REMEMBERED_KEY) ?? {};
    delete mapa[userId];
    storage.setJson(REMEMBERED_KEY, mapa);
  },
};
